import { render, staticRenderFns } from "./relungku.vue?vue&type=template&id=f2331aae&scoped=true&"
import script from "./relungku.vue?vue&type=script&lang=js&"
export * from "./relungku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2331aae",
  null
  
)

export default component.exports